"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "84729b5",
    "raw": "v2.16.1",
    "semverString": "2.16.1"
};
//# sourceMappingURL=version.js.map